import themed from '@/ui/Theme/themed'
import Button from './Button'
import EditButton from './EditButton'
import ButtonGroup from './ButtonGroup'

const themedButton = themed(Button)
const themedEditButton = themed(EditButton)
const themedButtonGroup = themed(ButtonGroup)

export { themedButton as Button }
export { themedEditButton as EditButton }
export { themedButtonGroup as ButtonGroup }
export default Button



// WEBPACK FOOTER //
// ./ui/Button/index.js